import { Http } from '../../support';

export const DEFAULT_AUTH_ME_INCLUDE = 'cliente,cliente.config,cliente.servicios,cliente.metadata,empresa,permissions';

export const createAuthMeParams = (include = DEFAULT_AUTH_ME_INCLUDE) => ({
  include,
});

export const fetchAuthMe = ({ params, include, headers } = {}) => {
  const requestParams = params || createAuthMeParams(include);
  return Http.get('/auth/me', { params: requestParams, headers });
};
